import classNames from 'classnames';
import React from 'react';
import Heading from 'wix-style-react/Heading';
import { i18n } from '../../utils';
import { typography } from '../common';
import { GoogleSignInButton } from './google-sign-in-button/google-sign-in-button';
import styles from './login-form.scss';
export var LoginForm = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement("div", { className: styles.loginForm, "data-hook": "login-form" },
        React.createElement("div", { className: styles.loginFormContent },
            React.createElement("div", { className: styles.welcomeTexts },
                React.createElement(Heading, null, i18n.t('login.welcome-message')),
                React.createElement("div", { className: classNames(styles.welcomeDescription, typography.t1) }, i18n.t('login.welcome-description'))),
            React.createElement("div", { className: styles.googleSignInButton },
                React.createElement(GoogleSignInButton, { onClick: onClick, buttonText: i18n.t('login.sing-in-with-google') }))),
        React.createElement("div", { className: styles.poweredBy },
            React.createElement("span", { className: styles.wixMPLogo }),
            React.createElement("span", { className: styles.googlePlatformLogo }))));
};
